<template>
  <div class="input-affix">
    <i class="prefix-icon anticon anticon-search"></i>
    <input type="text" class="form-control" placeholder="Поиск" />
  </div>
</template>

<script>
export default {
  name: "Search",
};
</script>

<style lang="scss" scoped></style>
